import React, { useState, useEffect } from 'react';
import Wrapper from '../../Main/Universal/Wrapper';
import { postAPI } from '../../../app/api';
import Swal from 'sweetalert2';

export default function NoticeCategoryManagement() {
    const [categories, setCategories] = useState([]);
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        status: 1
    });

    // Fetch categories
    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await postAPI('notice-category/list', {});
            if (response?.status === 1) {
                const cats = response?.data || [];
                setCategories(cats);
                if (cats.length > 0 && !activeTab) {
                    setActiveTab(cats[0].id);
                    fetchNoticesForCategory(cats[0].id);
                }
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            Swal.fire('Error', 'Failed to fetch categories', 'error');
        } finally {
            setLoading(false);
        }
    };

    const fetchNoticesForCategory = async (categoryId) => {
        try {
            // Get the category name from the selected category
            const selectedCategory = categories.find(c => c.id === categoryId);
            if (selectedCategory) {
                const response = await postAPI('notice/list-by-category', { category: selectedCategory.name });
                if (response?.status === 1) {
                    setNotices(response?.data || []);
                }
            }
        } catch (error) {
            console.error('Error fetching notices:', error);
        }
    };

    // Handle form changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
        }));
    };

    // Add/Update category
    const handleAddCategory = async (e) => {
        e.preventDefault();
        try {
            if (!formData.name.trim()) {
                Swal.fire('Validation', 'Please enter category name', 'warning');
                return;
            }

            let submitData = {
                name: formData.name,
                description: formData.description,
                status: formData.status
            };

            if (editingId) submitData.id = editingId;

            const response = await postAPI('notice-category/create', submitData);
            if (response?.status === 1) {
                Swal.fire('Success', 'Category saved successfully', 'success');
                resetForm();
                fetchCategories();
            } else {
                Swal.fire('Error', response?.msg || 'Failed to save category', 'error');
            }
        } catch (error) {
            console.error('Error saving category:', error);
            Swal.fire('Error', error.message || 'Failed to save category', 'error');
        }
    };

    // Delete category
    const handleDeleteCategory = async (id) => {
        const result = await Swal.fire({
            title: 'Confirm Delete',
            text: 'Are you sure you want to delete this category? Associated notices will be moved to default category.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const response = await postAPI('notice-category/delete', { id });
                if (response?.status === 1) {
                    Swal.fire('Success', 'Category deleted successfully', 'success');
                    fetchCategories();
                    setActiveTab(null);
                }
            } catch (error) {
                Swal.fire('Error', 'Failed to delete category', 'error');
            }
        }
    };

    const resetForm = () => {
        setFormData({
            name: '',
            description: '',
            status: 1
        });
        setShowForm(false);
        setEditingId(null);
    };

    const handleToggleForm = () => {
        if (showForm) {
            setShowForm(false);
            resetForm();
        } else {
            setEditingId(null);
            setFormData({
                name: '',
                description: '',
                status: 1
            });
            setShowForm(true);
        }
    };

    const handleEditCategory = (category) => {
        setFormData({
            name: category.name || '',
            description: category.description || '',
            status: category.status || 1
        });
        setEditingId(category.id);
        setShowForm(true);
    };

    const handleTabChange = (categoryId) => {
        setActiveTab(categoryId);
        fetchNoticesForCategory(categoryId);
    };

    return (
        <div className="container-fluid">
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Notice Category Management</h3>
                        {/* <button
                            className="btn btn-primary"
                            onClick={handleToggleForm}
                        >
                            {showForm ? 'Cancel' : 'Add New Category'}
                        </button> */}
                        <button className="btn btn-primary"
                            onClick={() => {
                                resetForm();
                                document.getElementById("openCategoryModalBtn").click();
                            }}
                        >
                            {showForm ? 'Cancel' : 'Add New Category'}
                        </button>
                    </div>
                </div>
            </div>
            <button
                id="openCategoryModalBtn"
                className="d-none"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#categoryModal"
            ></button>
            {/* {showForm && (
                <div className="card mb-4">
                    <div className="card-body">
                        <h5 className="card-title">{editingId ? 'Edit Category' : 'Add New Category'}</h5>
                        <form onSubmit={handleAddCategory}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Category Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="e.g., General Club Notice, Rules & Procedure"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-control"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Inactive</option>
                                    </select>
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        rows="3"
                                        placeholder="Enter category description (optional)"
                                    ></textarea>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-success">
                                {editingId ? 'Update' : 'Add'} Category
                            </button>
                        </form>
                    </div>
                </div>
            )} */}
            <div className="modal fade modal-white" id="categoryModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-md modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">
                                {editingId ? "Edit Category" : "Add New Category"}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleAddCategory}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Category Name *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="e.g., General Club Notice, Rules & Procedure"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows="3"
                                            placeholder="Enter category description (optional)"
                                        ></textarea>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-success">
                                    {editingId ? 'Update' : 'Add'} Category
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-3">
                    <div className="card gallery-list">
                        <div className="card-body">
                            <h6 className="card-title mb-3">Categories</h6>
                            {loading ? (
                                <div className="text-center py-3">
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="list-group">
                                    {categories && categories.length > 0 ? (
                                        categories.map((category, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                className={`list-group-item list-group-item-action ${activeTab === category.id ? 'active' : ''}`}
                                                onClick={() => handleTabChange(category.id)}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="text-start flex-grow-1">
                                                        <h6 className="mb-1">{category.name}</h6>
                                                        <small className={`badge badge-${category.status === 1 ? 'success' : 'danger'}`}>
                                                            {category.status === 1 ? 'Active' : 'Inactive'}
                                                        </small>
                                                    </div>
                                                    <div className="dropdown">
                                                        <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            •••
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end">
                                                            <li>
                                                                <a className="dropdown-item text-primary" href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleEditCategory(category);
                                                                }}>
                                                                    Edit
                                                                </a>
                                                            </li>
                                                            <li><hr className="dropdown-divider" /></li>
                                                            <li>
                                                                <a className="dropdown-item text-danger" href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDeleteCategory(category.id);
                                                                }}>
                                                                    Delete
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </button>
                                        ))
                                    ) : (
                                        <div className="alert alert-info mb-0">No categories found</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-lg-9">
                    <div className="card">
                        <div className="card-body">
                            {activeTab ? (
                                <>
                                    <h6 className="card-title mb-3">
                                        Notices in "{categories.find(c => c.id === activeTab)?.name || 'Category'}"
                                    </h6>
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover table-sm">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Date</th>
                                                        <th>Description</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {notices && notices.length > 0 ? (
                                                        notices.map((notice, index) => (
                                                            <tr key={index}>
                                                                <td><strong>{notice.title}</strong></td>
                                                                <td><small>{new Date(notice.notice_date).toLocaleDateString()}</small></td>
                                                                <td><small>{notice.description?.substring(0, 30)}...</small></td>
                                                                <td>
                                                                    <span className={`badge badge-sm badge-${notice.status === 1 ? 'success' : 'danger'}`}>
                                                                        {notice.status === 1 ? 'Active' : 'Inactive'}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4">
                                                                <small className="text-muted">No notices in this category</small>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="alert alert-info">
                                    Select a category from the left panel to view its notices
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
